module.exports = __webpack_public_path__ + "media/images/loginArc-9fc0866224babdc01561afc29c846cfd.svg";